import { FC } from 'react'
import { useSelector } from 'react-redux'
import { instanceInfoSlice } from '@wellesley/instanceinfo'

import ReportList from '../ReportList'
import RulesReport from '../RulesReport'
import NotFunReport from '../NotFanReport'
import CommonReport from '../CommonReport'
import { REPORT_STEP } from '../ReportList/options'

import { ReportModalContentProps } from './types'

const ModalContent: FC<ReportModalContentProps> = ({
  onMute,
  notFunAction,
  setNotFunAction,
  groupRules,
  showSuccess,
  onSelectedOption,
  selectedOption,
  ...props
}) => {
  const instanceInfo = useSelector(
    instanceInfoSlice.selectors.selectInstanceInfo,
  )
  const serverRules = instanceInfo?.rules || []

  switch (true) {
    case selectedOption === 'list':
      return (
        <ReportList
          {...props}
          hasGroupRules={!!groupRules}
          onChange={(opt: REPORT_STEP) => onSelectedOption(opt)}
        />
      )
    case selectedOption === 'server_rules':
      return (
        <RulesReport
          {...props}
          rules={serverRules}
          entity="server"
          onSuccess={showSuccess}
        />
      )
    case selectedOption === 'group_rules':
      return (
        <RulesReport
          {...props}
          rules={groupRules || []}
          entity="group"
          onSuccess={showSuccess}
        />
      )
    case selectedOption === 'not_fan':
      return (
        <NotFunReport
          {...props}
          onMute={onMute}
          action={notFunAction}
          onSuccess={showSuccess}
          onChange={setNotFunAction}
        />
      )
    default:
      return (
        <CommonReport
          {...props}
          currentStep={selectedOption}
          onSuccess={showSuccess}
        />
      )
  }
}

export default ModalContent
